import * as React from "react";
import { Show, SimpleShowLayout, TextField, DateTimeInput } from 'react-admin';

export const TrackShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="imei" />
            <DateTimeInput source="sd" />
            <DateTimeInput source="ed" />
        </SimpleShowLayout>
    </Show>
);